import { Component, OnInit, ViewChild } from '@angular/core';
import { ApiService } from '../../../../services/main/api.service';
import { NgbModal, ModalDismissReasons, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import Swal from 'sweetalert2';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { Storage } from '@ionic/storage';
import { Router, ActivatedRoute } from '@angular/router';
import { Global } from '../../../../services/global';
import { BaseCrudComponent } from '../../../base-crud/base-crud.component';
import { TranslateService } from '@ngx-translate/core';
import { Observable, BehaviorSubject, of, throwError, from } from 'rxjs';
import { mergeMap, catchError, timeout, retry } from 'rxjs/operators';
import { ExportAsService, ExportAsConfig } from 'ngx-export-as';
import * as moment from 'moment-timezone';

import { LazyLoadEvent } from 'primeng/api';
import { SelectItem } from 'primeng/api';
import {MessageService} from 'primeng/api';

import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';



@Component({
  selector: 'app-myroutes',
  templateUrl: './myroutes.component.html',
  styleUrls: ['./myroutes.component.css']
})
export class MyroutesComponent extends BaseCrudComponent {

    translations:any;
    momentjs: any = moment;
    curr_date:any;
    today:any;
    dstart:any;

    loadingRequired:any;
    status:any;
    assigned:any;
    inprogress:any;
    seltab = 0;

    offline_key_list = 'LOGI_DRIVER_ROUTES';
    offline_date = '';

    constructor(
        srv: ApiService,
        modalService: NgbModal,
        storage: Storage,
        router: Router,
        private route: ActivatedRoute,
        public translate: TranslateService
      ) {
        super(srv, modalService, storage, router);

        this.read_url = 'LogisticRoute/GetAssignedList';
        this.create_url = 'LogisticTruck/Create';
        this.update_url = 'LogisticTruck/Update';
        this.delete_url = 'LogisticTruck/LogicalDelete';
        this.search_fields = [];
        this.loadingRequired = false;
        this.assigned = [];
        this.inprogress = [];

        this.srv.offline.subscribe(r => {
            this.isOffline = r;
        });

        this.reload.subscribe(val => {
            if( val ){
                super.clearData();
                this.getList();
                
            }
        });
    }

    ngOnInit() {
        this.curr_date = this.momentjs().tz('America/Guayaquil').format('YYYY-MM-DD');
        this.today = this.momentjs().tz('America/Guayaquil').format('YYYY-MM-DD');
        this.f_datefrom = this.curr_date;

        this.translate.getTranslation(this.translate.currentLang)
        .subscribe((translations) => {
                this.translations = translations;
                super.ngOnInit();
                this.getList();
        });
    }

    getList(){
        this.clearData();

        if(this.isOffline){
            this.srv.getOfflineData(this.offline_key_list).then(x => {
                //console.log(x);
                var rs = x.data;
                if( (rs != null) && (rs != undefined) ){
                    this.parseOfflineData(rs, this.f_datefrom);
                    this.offline_date = x.last_update;
                }
            });
        }
        else{
            this.loadingList = true;

            this.srv.postCall(this.read_url, {date:this.f_datefrom}).subscribe(x => {
                  var data = x.data;
                  this.loadingList = false;

                  if(x.status){
                      this.assigned = data;
                  }

                  this.loadingList = true;
                  this.getProgressList().subscribe(b => {
                        this.loadingList = false;
                  
                        if( b != false ){
                            this.inprogress = b;
                        }

                        this.srv.getOfflineData(this.offline_key_list).then(x => {
                            //console.log(x);
                            let rs:any;

                            if( (x == null) || (x == undefined) ){
                                rs = {};
                            }
                            else{
                                rs = x.data;
                            }

                            rs[this.f_datefrom] = {assigned: this.assigned, inprogress: this.inprogress};
                            this.srv.saveOfflineData(this.offline_key_list, rs);
                        });
                  });
              });
        }
    }

    parseOfflineData(rs:any, from:any){
        if( rs[from] != undefined ){
            this.assigned = rs[from]['assigned'];
            this.inprogress = rs[from]['inprogress'];
        }
    }

    public getProgressList(){
        var par_url = 'LogisticRoute/GetInProgressList';

        return this.srv.postCall(par_url, {date:this.f_datefrom}).pipe(
                    mergeMap(x => {
                        let mydata:any = {status: false, message:'', data:[]};
                        mydata = x;
                        
                        if(mydata.status == true ){
                          return of(mydata.data);
                        }
                        else{
                          return of(false);
                        }
                      }),
                      //timeout(MAX_TIME),
                      catchError(data => of(false))
                );
    }

    openCreateModal(content:any){
        this.c_obj = {};
        super.openCreateModal(content);
    }

    openUpdateModal(content:any, obj:any){
        this.u_obj = obj;
        super.openCreateModalLG(content);
    }

    validateCreateInfo(fields:any){
        let mygroup:any = {};
        mygroup = new FormGroup({
            'name': new FormControl(fields.name, [Validators.required]),
            'type': new FormControl(fields.type, [Validators.required]),
            'brand': new FormControl(fields.brand, [Validators.required]),
            'registrationNumber': new FormControl(fields.registrationNumber, [Validators.required]),
            'registrationExpiration': new FormControl(fields.registrationExpiration, [Validators.required]),
            'productionYear': new FormControl(fields.productionYear, [Validators.required]),
            'driverId': new FormControl(fields.driverId, [Validators.required]),
            'weightUMId': new FormControl(fields.weightUMId, [Validators.required]),
            'columetUMId': new FormControl(fields.columetUMId, [Validators.required]),
        });

        return mygroup.valid;
    }

    public createItem(content:any, form:any){
        var validated = true;

        if( form == undefined ){
          form = {};
        }

        validated = this.validateCreateInfo(form);
        if( !validated ){
            Swal.fire(this.translations['msg_all_required'], '', 'error');
            return;
        }

        var to:any;
        to = form;

        var qst = this.create_url;
        this.isCreating = true;

        this.srv.postCall(qst, to).subscribe(x => {
            this.isCreating = false;
            if(x.status){
                this.c_obj = {};
                this.getList();
                this.closeModal(content);
                Swal.fire('Creado', '', 'success');
            }//end success
            else{
                //Swal.fire(this.translations[x.msg], '', 'error');
                Swal.fire(x.message, '', 'error');
            }
        });
    }

    public updateItem(content:any, form:any){
        var validated = true;

        if( form == undefined ){
          form = {};
        }

        validated = this.validateCreateInfo(form);
        if( !validated ){
            Swal.fire(this.translations['msg_all_required'], '', 'error');
            return;
        }

        var to:any;
        to = form;

        var qst = this.update_url;
        this.isUpdating = true;

        this.srv.postCall(qst, to).subscribe(x => {
            this.isUpdating = false;
            if(x.status){
                this.getList();
                this.closeModal(content);
                Swal.fire(this.translations['updated'], '', 'success');
            }//end success
            else{
                Swal.fire(x.message, '', 'error');
              //this.closeModal(content);
            }
        });
    }

    public setInProgress(obj:any){
        var qst = 'LogisticRoute/SetToInProgress';
        let trans = this.translations;
        
        if(this.isOffline){
            Swal.fire('Acción No Disponible Modo Offline', '', 'warning');
            return;
        }

        Swal.fire({
            title: 'Iniciar Ruta?',
            text: '',
            icon: 'success',
            showCancelButton: true,
            showLoaderOnConfirm: true,
            cancelButtonText: trans.cancel,
            confirmButtonText: 'Go!',
            preConfirm: () => {
                this.srv.postCall(qst, obj).subscribe(x => {
                    //let msg = this.translateMessage(x.msg);
                    let msg = 'Ruta esta ahora en progreso!';

                    if(x.status){
                        this.seltab = 1;
                        this.getList();
                        Swal.fire(trans.success, msg, 'success');
                    }
                    else{
                        Swal.fire(msg, '', 'error');
                    }
                });
            }
        }).then((result) => {
        });
    }

}
